import React, {Component} from "react"
import {Link} from "react-router-dom"

import {Location} from "~/utils/ShelfEntities"
import Button from "~/components/Button"
import {handleDestroyError} from "."
import {withTranslation} from "react-i18next"

const icon = require("~/icons/location_32_blue.svg")
const icon_delete = require("~/icons/action_delete.svg")
const icon_edit = require("~/icons/action_edit.svg")

class ListItemLocation extends Component {
  destroyLocation() {
    if (window.confirm(this.props.t("locations.deleteConfirmation"))) {
      Location.destroy(this.props.barcode)
        .then(() => this.props.update())
        .catch(handleDestroyError)
    }
  }
  render() {
    return (
      <div className="sh-list-item">
        <img src={icon} alt={"Location"} />
        <div className="content">
          <Link to={`/location/${this.props.barcode}`}>
            <div className="primary">{this.props.name}</div>
            <div className="secondary">
              {this.props.area ? this.props.area.name : null}
            </div>
          </Link>
        </div>

        {!this.props.disableActions && (
          <div className="actions">
            <Button
              onClick={this.destroyLocation.bind(this)}
              icon={icon_delete}
              label={this.props.t("delete")}
            />
            <Button
              to={"/locations/" + this.props.barcode}
              icon={icon_edit}
              label={this.props.t("edit")}
            />
          </div>
        )}
      </div>
    )
  }
}

export default withTranslation()(ListItemLocation)



// WEBPACK FOOTER //
// ./src/components/list_items/ListItemLocation.js